import isLoan from "./isLoan";
/**
 * This function returns a flag indicating a loan has been paid off.
 * > (currentBalance must be <= 0, not pre-delivery, and account is a loan productType)
 *
 * @param currentBalance string value of the current balance e.g. "123"
 * @param isPreDelivery boolean indicating if the loan is pre-delivery or not.
 * @param productType Product type assigned to the account
 * @returns boolean indicating a loan has been paid off.
 */
var loanPaidOff = function (_a) {
    var currentBalance = _a.currentBalance, isPredelivery = _a.isPredelivery, productType = _a.productType;
    return +currentBalance <= 0 && !isPredelivery && isLoan(productType);
};
export default loanPaidOff;
//# sourceMappingURL=loanPaidOff.js.map